import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvConfig } from '@core/config';
import { AppStoreQuery } from '@core/state';
import { Observable } from 'rxjs';

@Injectable()
export class AiEngineApiInterceptor implements HttpInterceptor {
    private readonly LANGUAGE_STORAGE_KEY = 'wai_user_language';

    constructor(
        private env: EnvConfig,
        private query: AppStoreQuery
    ) { }

    public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const aiEngineApiUrl = this.env.aiEngineApiUrl;

        // Check if this is an AI Engine API request
        if (!aiEngineApiUrl || !request.url.startsWith(aiEngineApiUrl)) {
            return next.handle(request);
        }

        // Get theme and language data from localStorage
        const initialTheme = JSON.parse(localStorage.getItem('initialThemeParams') || '{}');
        const activeTheme = JSON.parse(localStorage.getItem('activeTheme') || '{}');
        const currentLanguage = localStorage.getItem(this.LANGUAGE_STORAGE_KEY);

        const isThemeSame = initialTheme?.uid === activeTheme?.uid;
        const partnerDomainId = initialTheme?.uid || '';
        const selectedPartnerId = activeTheme?.uid || '';
        const selectedPartnerValue = isThemeSame ? '' : selectedPartnerId || '';

        // Get authentication token
        const token = this.query.getAuthenticationToken();

        // Build headers
        const isFileUpload = request.url.includes("extract_document_bytes") || request.url.includes("run-que-module") || request.body instanceof FormData;

        let headers = request.headers;
        if (!isFileUpload) {
            headers = headers.set('Accept', 'application/json');
            headers = headers.set('Content-Type', 'application/json');
        }
        headers = headers.set('X-Partner-Domain', partnerDomainId || '');
        headers = headers.set('X-Selected-Partner', selectedPartnerValue);

        // Set X-Language header only if language exists
        if (currentLanguage != null) {
            headers = headers.set('X-Language', currentLanguage);
        }

        // Set X-API-Token header if token exists
        if (token) {
            headers = headers.set('X-API-Token', token);
        }

        // Clone request with new headers
        const clonedRequest = request.clone({
            headers: headers,
        });

        return next.handle(clonedRequest);
    }
}
